// src/app/admin/page.tsx

"use client";

import { Card, Layout, Spin, Typography } from "antd";
import dynamic from "next/dynamic";
import type React from "react";

const AdminPortal = dynamic(() => import("@/components/AdminPortal"), {
  ssr: false,
  loading: () => <Spin size="large" />,
});
const AnalyticsPortal = dynamic(() => import("@/components/AnalyticsPortal"), {
  ssr: false,
  loading: () => <Spin size="large" />,
});
const Tabs = dynamic(() => import("antd").then((mod) => mod.Tabs), { ssr: false });

const { Title } = Typography;
const { Content } = Layout;

const AdminPage: React.FC = () => {
  const items = [
    {
      key: "1",
      label: "Admin Portal",
      children: (
        <div className="p-4">
          <AdminPortal />
        </div>
      ),
    },
    {
      key: "2",
      label: "Analytics Portal",
      children: (
        <div className="p-4">
          <AnalyticsPortal />
        </div>
      ),
    },
  ];

  return (
    <Layout className="min-h-screen bg-gray-50 p-6">
      <Content>
        <Card className="shadow-lg rounded-lg">
          <Title level={2} className="text-center mb-4">
            Admin Dashboard
          </Title>
          <Tabs
            defaultActiveKey="1"
            centered
            tabBarGutter={64}
            type="line"
            size="large"
            className="custom-tabs"
            items={items}
          />
        </Card>
      </Content>
    </Layout>
  );
};

export default AdminPage;
